import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
import { GoodTableOptions } from '@/components/GoodTable/GoodTable.types';
import _ from 'lodash';
export class SettingsTableOptions extends GoodTableOptions {
    constructor() {
        super(...arguments);
        this.rows = [];
    }
}
export const wordingFields = ['name', 'cn', 'en', 'jp', 'tw'];
let MailService = class MailService {
    constructor(mailApi, i18n, packagesService) {
        this.mailApi = mailApi;
        this.i18n = i18n;
        this.packagesService = packagesService;
        this.optionsSources = [];
        this.optionsRegions = [];
        this.optionsLabels = [];
        this.get_mail_source = this.mailApi.get_mail_source;
        this.get_mail_region = this.mailApi.get_mail_region;
        this.get_mail_created_period = this.mailApi.get_mail_created_period;
        this.get_mail_label = this.mailApi.get_mail_label;
        this.get_mail_notification_type = this.mailApi.get_mail_notification_type;
        // Mail Setting
        this.mailSettingStore = {
            mailTypes: [],
            allUnsubReasons: [],
            labels: [],
        };
    }
    // Updates
    updateMailSource() {
        return this.get_mail_source().then(res => {
            this.optionsSources = res;
        });
    }
    updateMailRegions() {
        return this.get_mail_region().then(res => {
            this.optionsRegions = res;
        });
    }
    updateMailLabels() {
        return this.get_mail_label().then(res => {
            this.optionsLabels = res;
        });
    }
    getMailSendList(queryDatas) {
        return this.mailApi.getMailSendList(queryDatas);
    }
    getMailStatus(params) {
        return this.mailApi.getMailStatus(params);
    }
    postMailResend(emailIds) {
        return this.mailApi.postMailResend(emailIds);
    }
    getMailReceiptList(queryDatas) {
        return this.mailApi.getMailReceiptsList(queryDatas);
    }
    getMailUnreachableList(queryDatas) {
        return this.mailApi.getMailUnreachableList(queryDatas);
    }
    deleteMailUnreachable(queryDatas) {
        return this.mailApi.deleteMailUnreachable(queryDatas);
    }
    patchMailUnreachable(queryDatas) {
        return this.mailApi.patchMailUnreachable(queryDatas);
    }
    postMailUnreachable(emails) {
        return this.mailApi.postMailUnreachable(emails);
    }
    getLabelNameBySystemCodeObj(params) {
        if (!params)
            return;
        if (this.i18n.locale === 'cn') {
            return params.zh_CN;
        }
        return params.en_US;
    }
    getOptionLabelNameByCode(options, code) {
        const item = options.find(item => item.system_code === code);
        if (item) {
            return this.getLabelNameBySystemCodeObj(item.system_code_text);
        }
        else {
            console.error(`getOptionLabelNameByCode labelName not found: ${code}`);
            return code;
        }
    }
    getMailSettingList(queryDatas) {
        return this.mailApi.getMailSettingList(queryDatas);
    }
    async syncMailSetting(payload) {
        if (payload.id) {
            await this.mailApi.updateMailSetting(payload);
        }
        else {
            await this.mailApi.createMailSetting(payload);
        }
    }
    async updateMailLabelOptions() {
        this.mailSettingStore.labels = await this.mailApi.getMailLabelOptions();
    }
    async updateMailTypeList() {
        const typelist = await this.mailApi.updateMailTypeList();
        this.mailSettingStore.mailTypes = typelist;
    }
    getMailTypeFileById(id, fieldName) {
        return this.mailSettingStore.mailTypes.find(t => t.id === id)?.[fieldName];
    }
    async syncMailType(payload) {
        if (payload.id) {
            await this.mailApi.updateMailType(payload);
        }
        else {
            await this.mailApi.createMailType(payload);
        }
    }
    async syncReasons(payload) {
        if (payload.id) {
            await this.mailApi.updateMailUnsubReason(payload);
        }
        else {
            await this.mailApi.createMailUnsubReason(payload);
        }
    }
    async updateAllUnsubReasonsStore(force = false) {
        if (force || _.isEmpty(this.mailSettingStore.allUnsubReasons)) {
            this.mailSettingStore.allUnsubReasons = await this.mailApi.getMailUnsubReasons();
        }
    }
    getUnsubReasonsBySettingId(id) {
        return this.mailApi.getMailUnsubReasons(id);
    }
    getEntityMailConfig(type, entity_id) {
        return this.mailApi.getEntityMailConfig(type, entity_id);
    }
    syncEntityMailConfig(type, entity_id, payload) {
        return this.mailApi.syncEntityMailConfig(type, entity_id, payload);
    }
    postMailReasonBatch(params) {
        return this.mailApi.postMailReasonBatch(params);
    }
    postMailTypeBatch(params) {
        return this.mailApi.postMailTypeBatch(params);
    }
};
MailService = __decorate([
    injectable(),
    __param(0, inject(Symbols.MailApi)),
    __param(1, inject(Symbols.I18n)),
    __param(2, inject(Symbols.PackagesService)),
    __metadata("design:paramtypes", [Object, Object, Object])
], MailService);
export { MailService };
export function deleteSearchQuery(queryObj, startStr = 's_') {
    const draft = { ...queryObj };
    for (const key in draft) {
        if (key.startsWith(startStr)) {
            delete draft[key];
        }
    }
    return draft;
}
export function getBooleanOptions(trueText, falseText) {
    return [
        { text: trueText, value: true },
        { text: falseText, value: false }
    ];
}
export function getSendTypeOptions(trueText, falseText) {
    return [
        { text: trueText, value: 'trigger' },
        { text: falseText, value: 'batch' }
    ];
}
export function jsonParamsConvert(d = {}, isStringify = false) {
    if (!isStringify) {
        // @ts-ignore
        return d.jsonParams ? JSON.parse(d.jsonParams) : {};
    }
    return { jsonParams: JSON.stringify(d) };
}
